export const reducer = (state, action) => {
    const { type, value } = action
    switch (type) {
        case 'AUTH_STATE_CHANGE':
            return { ...state, ...value }
        default:
            return { ...state, ...value }
    }
}
